import { ItemHeaderComponent } from './item-header.component';

export default angular
  .module('sfMobile.components.item-header', [])
  .component('sfItemHeader', ItemHeaderComponent).name;
